import type { AnalyticsState, HubbleExperiment } from '../types';

export interface Experiment {
  variant: string;
  name: string;
}

export const experimentsReducer = (
  state: AnalyticsState,
  props: Experiment,
): AnalyticsState => ({
  ...state,
  hubbleExperiments: {
    ...state.hubbleExperiments,
    [props.name]: {
      name: props.name,
      variant: props.variant,
      participantStatus: 'enrolled',
    } satisfies HubbleExperiment,
  },
});
